var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFireButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 81,
    viewBox: "0 0 77 81",
    width: 77,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 42.540816,
    fill: "#1d2574",
    rx: 38,
    ry: 37.959184
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 38,
    cy: 38.459184,
    fill: "#2b3594",
    rx: 38,
    ry: 37.959184
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 52.75-14.6946313 7.8799334 2.8064248-16.6899667-11.8882064-11.8199001 16.4290972-2.4350333 7.3473157-15.1850333 7.3473157 15.1850333 16.4290972 2.4350333-11.8882064 11.8199001 2.8064248 16.6899667z",
    fill: "#1d2574"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireButton);
export default __webpack_public_path__ + "static/media/fire-button.8f560c41d8098b314d6a289295e58809.svg";
export { ForwardRef as ReactComponent };